import React, { useState, useEffect } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
} from 'reactstrap';
import { Link } from 'react-scroll';
import styles from './NavBar.module.css';
import { MdPhoneInTalk } from 'react-icons/md';


const MyNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 769 : false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 769);
    // Initialize
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className={styles.bar}>
      <Navbar className={styles.navbar} style={{ position: "sticky", top: 0 }} expand='md'>
              <NavbarBrand href='/' className={styles.brand}>Yogsadhna varga</NavbarBrand>
              {isMobile && (
                <NavbarToggler onClick={toggle} className={styles.toggler}>
                  <span className={styles.togglerIcon} />
                </NavbarToggler>
              )}
        <Collapse isOpen={isOpen} navbar>
          <Nav className='mr-auto' navbar>
            <NavItem>
              <NavLink className={`${styles.pointer} ${styles.navLink}`}>
                <Link
                  activeClass='active'
                  to='GoToHome'
                  spy={true}
                  smooth={true}
                  duration={500}>
                  Home
                </Link>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={`${styles.pointer} ${styles.navLink}`}>
                <Link
                  activeClass='active'
                  to='GoToFaculty'
                  spy={true}
                  smooth={true}
                  duration={500}>
                  Programs
                </Link>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={`${styles.pointer} ${styles.navLink}`}>
                <Link
                  activeClass='active'
                  to='GoToClasses'
                  spy={true}
                  smooth={true}
                  duration={700}>
                  Our Studio
                </Link>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className={`${styles.pointer} ${styles.navLink}`}>
                <Link
                  activeClass='active'
                  to='GoToAboutUs'
                  spy={true}
                  smooth={true}
                  duration={900}>
                  Contact Us
                </Link>
              </NavLink>
            </NavItem>
          </Nav>
          <NavbarText><span><MdPhoneInTalk /></span> +91 9595562223 </NavbarText>

        </Collapse>
      </Navbar>
    </div>
  );
};

export default MyNavbar;
